import { useEffect, useRef } from "react";

export default function Institucional() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".inst-item").forEach((item, i) => {
              setTimeout(() => item.classList.add("inst-visible"), i * 120);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="institucional" className="py-16 lg:py-20 bg-[#0D0D0D] overflow-hidden" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="inst-item opacity-0 translate-x-[-24px] transition-all duration-700 relative">
            <div className="relative rounded-2xl overflow-hidden h-[420px] lg:h-[520px]">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20business%20consultant%20team%20meeting%20in%20modern%20office%2C%20diverse%20group%20of%20executives%20discussing%20strategy%2C%20premium%20corporate%20environment%2C%20warm%20golden%20light%2C%20sophisticated%20atmosphere%2C%20trust%20and%20expertise&width=700&height=520&seq=inst001&orientation=portrait"
                alt="Equipe Ferrarezi Benefícios"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            </div>

            {/* Decorative element */}
            <div className="absolute -top-4 -left-4 w-20 h-20 rounded-2xl border-2 border-[#FBC52D]/20 -z-10" />
          </div>

          {/* Right: Content */}
          <div className="inst-item opacity-0 translate-x-6 transition-all duration-700">
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="w-6 h-px bg-[#FBC52D]" />
              <span className="text-[#FBC52D] text-xs font-semibold tracking-widest uppercase">
                Sobre a Ferrarezi
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
              Não somos uma corretora. Somos um ecossistema de inovação para o RH.
            </h2>

            <p className="text-gray-400 text-lg leading-relaxed mb-6">
              A Ferrarezi nasceu para transformar a forma como as empresas enxergam e gerenciam seus benefícios. Somos uma consultoria futurística e tecnológica focada no futuro do RH, combinando gestão de dados, longevidade e estratégia em um único ecossistema.
            </p>

            <p className="text-gray-400 text-base leading-relaxed mb-10">
              Unimos tecnologia de ponta, inteligência artificial e atendimento hiperpersonalizado para entregar resultados reais e mensuráveis para empresas e colaboradores.
            </p>

            {/* Values */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: "ri-brain-line", label: "Inovação e tecnologia" },
                { icon: "ri-shake-hands-line", label: "Ética e transparência" },
                { icon: "ri-bar-chart-2-line", label: "Decisões baseadas em dados" },
                { icon: "ri-heart-line", label: "Humanização do RH" },
              ].map((val) => (
                <div key={val.label} className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#FBC52D]/10 shrink-0">
                    <i className={`${val.icon} text-[#FBC52D] text-base`} />
                  </div>
                  <span className="text-white/80 text-sm font-medium">{val.label}</span>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mt-10 pt-8 border-t border-white/10">
              <button
                onClick={() => document.querySelector("#contato")?.scrollIntoView({ behavior: "smooth" })}
                className="whitespace-nowrap bg-[#FBC52D] text-black font-bold px-8 py-4 rounded-full hover:bg-[#d4a800] transition-all duration-200 cursor-pointer text-sm"
              >
                Fale com nossos especialistas
              </button>
              <button
                onClick={() => document.querySelector("#ecossistema")?.scrollIntoView({ behavior: "smooth" })}
                className="whitespace-nowrap border border-white/25 text-white font-semibold px-8 py-4 rounded-full hover:bg-white/10 hover:border-white/50 transition-all duration-200 cursor-pointer text-sm"
              >
                Conhecer o ecossistema
              </button>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .inst-visible {
          opacity: 1 !important;
          transform: translateX(0) !important;
        }
      `}</style>
    </section>
  );
}